import { AxiosResponse } from 'axios'
import { Action } from 'src/types/action'

import axios from '../../axios'

export const fetchActions = async (): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: Action[] }>('/api/action-logs/actions')
    .catch((error) => {
      return error.response
    })

  return response
}
